import { Plus, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function SpecsEditor({ specs, onChange, testid = "specs" }) {
  const update = (i, key, val) => {
    const next = specs.map((s, idx) => (idx === i ? { ...s, [key]: val } : s));
    onChange(next);
  };
  const add = () => onChange([...specs, { label: "", value: "" }]);
  const remove = (i) => onChange(specs.filter((_, idx) => idx !== i));

  return (
    <div className="space-y-2">
      {specs.map((s, i) => (
        <div key={i} className="flex gap-2">
          <Input
            data-testid={`${testid}-label-${i}`}
            value={s.label}
            onChange={(e) => update(i, "label", e.target.value)}
            placeholder="Характеристика"
            className="border-neutral-300"
          />
          <Input
            data-testid={`${testid}-value-${i}`}
            value={s.value}
            onChange={(e) => update(i, "value", e.target.value)}
            placeholder="Значение"
            className="border-neutral-300"
          />
          <Button type="button" variant="outline" size="icon" onClick={() => remove(i)} className="shrink-0 text-red-600">
            <X className="w-4 h-4" />
          </Button>
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" onClick={add} data-testid={`${testid}-add`}>
        <Plus className="w-3.5 h-3.5 mr-1" /> Добавить строку
      </Button>
    </div>
  );
}
